__turbopack_context__.v({
  "item-container": "mochi-parking-tutorial-vertical-list-module-scss-module__IrNNvG__item-container",
  "item-content": "mochi-parking-tutorial-vertical-list-module-scss-module__IrNNvG__item-content",
  "list": "mochi-parking-tutorial-vertical-list-module-scss-module__IrNNvG__list",
});
